import { render, staticRenderFns } from "./uploadGlobal.vue?vue&type=template&id=6bd12e22&scoped=true&"
import script from "./uploadGlobal.vue?vue&type=script&lang=js&"
export * from "./uploadGlobal.vue?vue&type=script&lang=js&"
import style0 from "./uploadGlobal.vue?vue&type=style&index=0&id=6bd12e22&lang=scss&scoped=true&"
import style1 from "./uploadGlobal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd12e22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd12e22')) {
      api.createRecord('6bd12e22', component.options)
    } else {
      api.reload('6bd12e22', component.options)
    }
    module.hot.accept("./uploadGlobal.vue?vue&type=template&id=6bd12e22&scoped=true&", function () {
      api.rerender('6bd12e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/uploadGlobal.vue"
export default component.exports